require("./kendo-ui/styles/kendo.common-bootstrap.css");
require("./kendo-ui/styles/kendo.bootstrap.css");
require("./kendo-ui/styles/kendo.bootstrap.mobile.css");
require("./kendo-ui/styles/kendo.z.css");

require("./kendo-ui/js/kendo.autocomplete");
require("./kendo-ui/js/kendo.binder");
require("./kendo-ui/js/kendo.colorpicker");
require("./kendo-ui/js/kendo.combobox");
require("./kendo-ui/js/kendo.core");
require("./kendo-ui/js/kendo.dataviz.chart");
require("./kendo-ui/js/kendo.dataviz.gauge");
require("./kendo-ui/js/kendo.datepicker");
require("./kendo-ui/js/kendo.datetimepicker");
require("./kendo-ui/js/kendo.dropdownlist");
require("./kendo-ui/js/kendo.editor");
require("./kendo-ui/js/kendo.grid");
require("./kendo-ui/js/kendo.listbox");
require("./kendo-ui/js/kendo.listview");
require("./kendo-ui/js/kendo.maskedtextbox");
require("./kendo-ui/js/kendo.menu");
require("./kendo-ui/js/kendo.mobile.buttongroup");
require("./kendo-ui/js/kendo.multiselect");
require("./kendo-ui/js/kendo.notification");
require("./kendo-ui/js/kendo.router");
require("./kendo-ui/js/kendo.scheduler");
require("./kendo-ui/js/kendo.splitter");
require("./kendo-ui/js/kendo.tabstrip");
require("./kendo-ui/js/kendo.timepicker");
require("./kendo-ui/js/kendo.tooltip");
require("./kendo-ui/js/kendo.treeview");
require("./kendo-ui/js/kendo.upload");
require("./kendo-ui/js/cultures/kendo.culture.en-GB");
require("./kendo-ui/js/cultures/kendo.culture.es-MX");
require("./kendo-ui/js/cultures/kendo.culture.ja-JP");
require("./kendo-ui/js/cultures/kendo.culture.fr-CA");
require("./kendo-ui/js/cultures/kendo.culture.fr-FR");
require("./kendo-ui/js/cultures/kendo.culture.en-QT");
require("./kendo-ui/js/cultures/kendo.culture.en-AU");
require("./kendo-ui/js/cultures/kendo.culture.en-NZ");
require("./kendo-ui/js/cultures/kendo.culture.en-ZA");
require("./kendo-ui/js/kendo.panelbar");